import { ACTION_LOGOUT } from "@login/reducer/actions.type";
import {
  FETCH_LIST_BENE_REQUEST,
  FETCH_LIST_BENE_SUCCESS,
  FETCH_LIST_BENE_FAILURE,
  FETCH_ADD_BENE_PROFILE_REQUEST,
  FETCH_ADD_BENE_PROFILE_SUCCESS,
  FETCH_ADD_BENE_PROFILE_FAILURE,
  FETCH_ADD_BENE_TEMPLATE_REQUEST,
  FETCH_ADD_BENE_TEMPLATE_SUCCESS,
  FETCH_ADD_BENE_TEMPLATE_FAILURE,
  RESET_LIST_BENE,
  SET_BENE_STORE,
} from "./actions.type";

import { BeneActions, BeneState } from "./types";

const initialState: BeneState = {
  pending: false,
  listBene: undefined,
  addProfile: undefined,
  addSuccess: false,
};

export default (state = initialState, action: BeneActions): BeneState => {
  switch (action.type) {
    case SET_BENE_STORE:
      return {
        ...state,
        ...action?.payload,
      };
    case FETCH_LIST_BENE_REQUEST:
      return {
        ...state,
        pending: true,
        addSuccess: false,
      };
    case FETCH_LIST_BENE_SUCCESS:
      return {
        ...state,
        pending: false,
        listBene: action.payload,
      };
    case FETCH_LIST_BENE_FAILURE:
      return {
        ...state,
        pending: false,
      };
    case FETCH_ADD_BENE_PROFILE_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case FETCH_ADD_BENE_PROFILE_SUCCESS:
      return {
        ...state,
        addProfile: action.payload,
      };
    case FETCH_ADD_BENE_PROFILE_FAILURE:
      return {
        ...state,
      };
    case FETCH_ADD_BENE_TEMPLATE_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case FETCH_ADD_BENE_TEMPLATE_SUCCESS:
      return {
        ...state,
        addSuccess: true,
      };
    case FETCH_ADD_BENE_TEMPLATE_FAILURE:
      return {
        ...state,
        addSuccess: false,
      };
    case RESET_LIST_BENE:
      return {
        ...initialState,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
